
import React from 'react';
import ProfileSetup from './profile-setup/ProfileSetup';

const ProfileSetupPage = () => {
  return <ProfileSetup />;
};

export default ProfileSetupPage;
